import { PROLOGUE_MISSION } from '@/gameplay/missions/prologue';
import { SURVIVORS_MISSION } from '@/gameplay/missions/survivors';
import { DE_BEGRAFENIS_MISSION } from '@/gameplay/missions/deBegrafenis';

export const STORY_MISSIONS = [
  PROLOGUE_MISSION,
  SURVIVORS_MISSION,
  DE_BEGRAFENIS_MISSION,
] as const;
